import { aplClient } from "./apiClient";

const getMerckLabels = (params:  {deliveryNote: string; siteId: number; dropLocationId: number;} ) => {
    return aplClient().get(`mercklabels/${params.siteId}/${params.deliveryNote}/${params.dropLocationId}`);
};

const getMerckLocations = () => {
    return aplClient().get(`mercklabels/locations`);
};

export { getMerckLabels, getMerckLocations };
